export const allMenu = [
    {
        name: '迎新现场',
        key: 'yxxc',
        url: '/yxxc',
        icon: 'team',
        auth: 'zhxg_yxgl_yxxc:menu',
    },
    /*{
        name: '刷脸报到成功',
        key: 'success',
        url: '/success',
        icon: 'scan'
    },*/
    {
        name: '人脸识别报到',
        key: 'face',
        url: '/face',
        icon: 'scan',
        auth: 'zhxg_yxgl_rlsb:menu',
    },
    {
        name: '基础数据管理',
        key: 'jcsj',
        icon: 'hdd',
        children: [
            {
                name: '新生数据管理',
                url: '/newStudent',
                key: 'newStudent',
                auth: 'zhxg_yxgl_jcsj_xssjgl:menu',
            }, {
                name: '未报到学生管理',
                key: 'wbdStudent',
                url: '/wbdStudent',
                auth: 'zhxg_yxgl_jcsj_wbdxsgl:menu',
            }
            , {
                name: '学生照片管理',
                key: 'studentPhotoMng',
                url: '/studentPhotoMng',
                auth: 'zhxg_yxgl_jcsj_yxxszpgl:menu',
            }
            , {
                name: '手机号码维护',
                key: 'sjhmwh',
                url: '/sjhmwh',
                auth: 'zhxg_yxgl_jcsj_sjhmwh:menu',
            }
            /* , {
                name: '新生照片管理',
                key: 'xszpgl',
                url: '/xszpgl',
                auth: 'zhxg_yxgl_jcsj_xszpgl:menu',
            } */
            , {
                name: '邮寄数据管理',
                key: 'mailingManagement',
                url: '/mailingManagement',
                auth: 'zhxg_yxgl_jcsj_mailingManagement:menu',
            } ,{
                name: '班级QQ管理',
                key: 'bjqqManage',
                url: '/bjqqManage',
                auth: 'zhxg_yxgl_bjqqManage_menu',
            },{
                name:'学生班级分配',
                key:'distributeClass',
                url:'/distributeClass',
                auth: 'zhxg_yxgl_distributeClass_menu',
            },{
                name:'编学号规则管理',
                key:'editXhRuleManagement',
                url:'/editXhRuleManagement', 
                auth: 'zhxg_yxgl_editXhRuleManagement_menu',
            },{
                name:'学生班级管理',
                key:'classManagement',
                url:'/classManagement', 
                auth: 'zhxg_yxgl_classManagement_menu',
            }


        ]
    }, {
        name: '迎新流程管理',
        key: 'lcgl',
        icon: 'file-text',
        children: [
            {
                name: '环节管理',
                url: '/hjgl',
                key: 'hjgl',
                auth: 'zhxg_yxgl_lcgl_hjgl:menu',
            }, {
                name: '流程配置',
                url: '/lcpz',
                key: 'lcpz',
                auth: 'zhxg_yxgl_lcgl_lcpz:menu',
            }, {
                name: '环节分配',
                url: '/hjfp',
                key: 'hjfp',
                auth: 'zhxg_yxgl_lcgl_hjfp:menu',
            }
        ]
    }, {
        name: '统计查询',
        key: 'tjcx',
        icon: 'desktop',
        children: [
            {
                name: '学生报到统计',
                url: '/bdtjcx',
                key: 'bdtjcx',
                auth: 'zhxg_yxgl_tjcx_bdtjcx:menu',
            }, {
                name: '学院学生报到统计',
                url: '/bdtjcxFilterByCollege',
                key: 'bdtjcxFilterByCollege',
                auth: 'zhxg_yxgl_tjcx_bdtjcx_xy:menu',
            }, {
                name: '学生信息查询',
                url: '/xsxxcx',
                key: 'xsxxcx',
                auth: 'zhxg_yxgl_tjcx_xsxxcx:menu',
            }, {
                name: '学生缴费信息查询',
                url: '/xsjfxxcx',
                key: 'xsjfxxcx',
                auth: 'zhxg_yxgl_tjcx_xsjfxxcx:menu',
            }, {
                name: '学生缴费查询统计',
                url: '/xsjfcxtj',
                key: 'xsjfcxtj',
                auth: 'zhxg_yxgl_tjcx_xsjfcxtj:menu',
            }, {
                name: '学生住宿信息查询',
                url: '/zsxxcx',
                key: 'zsxxcx',
                auth: 'zhxg_yxgl_tjcx_zsxxcx:menu',
            }, {
                name: '学生办理信息汇总查询',
                url: '/xsblxxhzcx',
                key: 'xsblxxhzc',
                auth: 'scjtzyjsxy_yxgl_tjcx_xsblxxhzc:menu',
            }, {
                name: '环节办理查询',
                url: '/hjblcx',
                key: 'hjblcx',
                auth: 'zhxg_yxgl_tjcx_hjblcx:menu',
            }, {
                name: '环节办理详情查询',
                url: '/hjblxqcx',
                key: 'hjblxqcx',
                auth: 'zhxg_yxgl_tjcx_hjblxqcx:menu',
            }, {
                name: '环节办理业务项查询',
                url: '/hjblywxcx',
                key: 'hjblywxcx',
                auth: 'zhxg_yxgl_tjcx_hjblywxcx:menu',
            }, {
                name: '自助报到环节办理查询',
                url: '/zzbdblcx',
                key: 'zzbdblcx',
                auth: 'zhxg_yxgl_tjcx_zzbdblcx:menu',
            }, {
                name: '自助报到环节办理统计',
                url: '/zzbdtjcx',
                key: 'zzbdtjcx',
                auth: 'zhxg_yxgl_tjcx_zzbdtjcx:menu',
            }, {
                name: '学生信息采集查询',
                url: '/xsxxcjcx',
                key: 'xsxxcjcx',
                auth: 'zhxg_yxgl_tjcx_xsxxcjcx:menu',
            }, {
                name: '报到情况填写查询',
                url: '/bdqkcx',
                key: 'bdqkcx',
                auth: 'zhxg_yxgl_tjcx_bdqkcx:menu',
            }, {
                name: '生活用品查询',
                url: '/shypcx',
                key: 'shypcx',
                auth: 'zhxg_yxgl_tjcx_shypcx:menu',
            }, {
                name: '军训服装查询',
                url: '/jxfzcx',
                key: 'jxfzcx',
                auth: 'zhxg_yxgl_tjcx_jxfzcx:menu',
            }, {
                name: '校服服装查询',
                url: '/xffzcx',
                key: 'xffzcx',
                auth: 'zhxg_yxgl_tjcx_xffzcx:menu',
            }, {
                name: '绿色通道查询',
                url: '/lstdblcx',
                key: 'lstdblcx',
                auth: 'zhxg_yxgl_tjcx_lstdblcx:menu',
            }, {
                name: '宿舍住宿信息查询',
                url: '/sszsxxcx',
                key: 'sszsxxcx',
                auth: 'zhxg_yxgl_tjcx_sszsxxcx:menu'
            },
            {
                name: '业务项办理查询',
                url: '/ywxblcx',
                key: 'ywxblcx',
                auth: 'zhxg_yxgl_tjcx_ywxblcx:menu'
            }, {
                name: '手机号码汇总',
                url: '/sjhmhz',
                key: 'sjhmhz',
                auth: 'zhxg_yxgl_tjcx_sjhmhz:menu',
            },
            {
                name: '人脸识别信息查询',
                url: '/rlsbxxcx',
                key: 'rlsbxxcx',
                auth: 'zhxg_yxgl_tjcx_rlsb_xxcx:menu',
            },
            {
                name: '人脸识别信息查询',
                url: '/scjtRlsbxxcx',
                key: 'scjt_rlsbxxcx',
                auth: 'xmd_zhxg_yxgl_tjcx_rlsb_xxcx:menu',
            }, {
                name: '专业调整信息',
                url: '/zytzxx',
                key: 'zytzxx',
                auth: 'zhxg_yxgl_tjcx_zytzxx:menu',
            },

        ]
    }, {
        name: '服务网管理',
        key: 'fwwgl',
        icon: 'coffee',
        children: [
            {
                name: '导航栏目',
                url: '/dhlm',
                key: 'dhlm',
                auth: 'zhxg_yxgl_fwwgl_dhlmgl:menu',
            }, {
                name: '首页图片',
                url: '/sytp',
                key: 'sytp',
                auth: 'zhxg_yxgl_fwwgl_sytp:menu',
            }, {
                name: '首页链接',
                url: '/sylj',
                key: 'sylj',
                auth: 'zhxg_yxgl_fwwgl_syljgl:menu',
            }, {
                name: '信息发布',
                url: '/xxfb',
                key: 'xxfb',
                auth: 'zhxg_yxgl_fwwgl_xxfb:menu',
            }, {
                name: '报到流程',
                url: '/bdlc',
                key: 'bdlc',
                auth: 'zhxg_yxgl_fwwgl_bdlc:menu',
            }, {
                name: '快速导航',
                url: '/ksdh',
                key: 'ksdh',
                auth: 'zhxg_yxgl_fwwgl_ksdh:menu',
            }, {
                name: '联系方式',
                url: '/lxfs',
                key: 'lxfs',
                auth: 'zhxg_yxgl_fwwgl_lxfs:menu',
            }, {
                name: '在线问答',
                url: '/zxwd',
                key: 'zxwd',
                auth: 'zhxg_yxgl_fwwgl_zxwd:menu',
            }, {
                name: '自助报到',
                url: '/zzbd',
                key: 'zzbd',
                auth: 'zhxg_yxgl_fwwgl_zzbd:menu',
            }, {
                name: '生活物品管理',
                url: '/shwpgl',
                key: 'shwpgl',
                auth: 'zhxg_yxgl_fwwgl_shwpgl:menu',
            }, {
                name: '站台维护',
                url: '/ztwh',
                key: 'ztwh',
                auth: 'zhxg_yxgl_fwwgl_ztwh:menu',
            }, {
                name: '地图坐标维护',
                url: '/dtzbwh',
                key: 'dtzbwh',
                auth: 'zhxg_yxgl_fwwgl_dtzbwh:menu',
            }, {
                name: '视频管理',
                url: '/spgl',
                key: 'spgl',
                auth: 'zhxg_yxgl_fwwgl_spgl:menu',
            }
        ]
    },
    {
        name: '信息采集',
        key: 'xxcj',
        icon: 'edit',
        children: [
            {
                name: '表单管理',
                url: '/bdgl',
                key: 'bdgl',
                auth: 'zhxg_yxxt_xxcj_bdgl:menu'
            },
            {
                name: '字段管理',
                url: '/zdgl',
                key: 'zdgl',
                auth: 'zhxg_yxxt_xxcj_zdgl:menu'
            }
        ]
    }, {
        name: '事务办理',
        key: 'swbl',
        icon: 'solution',
        children: [
            {
                name: '绿色通道',
                url: '/lstd',
                key: 'lstd',
                auth: 'zhxg_yxgl_swbl_lstd:menu',
            }, {
                name: '专业调整',
                url: '/zytz',
                key: 'zytz',
                auth: 'zhxg_yxgl_swbl_zytz:menu',
            }, {
                name: '是否住宿',
                url: '/sfzs',
                key: 'sfzs',
                auth: 'jhyszy_yxgl_swbl_sfzs:menu',
            },
        ]
    }, {
        name: '在线缴费管理',
        key: 'zxjfgl',
        icon: 'pay-circle',
        children: [
            {
                name: '缴费方案管理',
                url: '/jffagl',
                key: 'jffagl',
                auth: 'zhxg_yxxt_zxjfgl_jffagl:menu',
            },
            {
                name: '缴费参数设置',
                url: '/jfcssz',
                key: 'jfcssz',
                auth: 'zhxg_yxxt_zxjfgl_jfcssz:menu',
            },
        ]
    }, {
        name: '实时统计',
        key: 'sstj',
        icon: 'bar-chart',
        children: [
            {
                name: '迎新实时数据统计',
                url: '/show',
                key: 'show',
                auth: 'zhxg_yxgl_sstj:menu',
            }, {
                name: '迎新流程实时数据统计',
                url: '/showTable',
                key: 'showTable',
                auth: 'zhxg_yxgl_sstj_flc:menu',
            },
            // {
            //     name: '迎新实时数据统计',//南华工商
            //     key: 'show_gdnh',
            //     url: '/gdnh-show',
            //     auth: 'zhxg_yxgl_sstj_gdnh:menu',
            // },
            // {
            //     name: '迎新实时数据统计',
            //     key: 'sstj_bxcc',
            //     url: '/show-zzsd',
            //     auth: 'zhxg_yxgl_sstj_bxcc:menu',
            // },
            {
                name: '迎新实时数据统计松山职业学院',
                key: 'sstj_sszy',
                url: '/sszy-show',
                auth: 'zhxg_yxgl_sstj_weakrate:menu',
            },
            {
                name: '迎新实时数据统计',
                key: 'sstj_bgy',
                url: '/bgy-show',
                auth: 'zhxg_yxgl_sstj_bgy:menu',    
            },
            {
                name: '迎新实时数据统计-长沙电力大学',
                key: 'sstj_csdl',
                url: '/csdl-show',
                auth: 'zhxg_yxgl_sstj_csdl:menu',    
            }
        ]
    }, {
        name: '录取查询信息维护',
        key: 'lqcx',
        url: '/lqcxxxwh', 
        icon: 'edit',
        auth: 'zhxg_yxgl_jscs_lqcx:menu'
    }, {
        name: '志愿者信息',
        key: 'zyzxx',
        url: '/zyzxx', 
        icon: 'hdd',
        auth: 'zhxg_yxgl_zyzxx:menu'
    }, {
        name: '转专业统计',
        key: 'zzytj',
        url: '/changeMajorStatic', 
        icon: 'bar-chart',
        auth: 'zhxg_yxgl_zyztj:menu'
    }

]


// WEBPACK FOOTER //
// ./utils/menu.js